/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import { HealthFragmentDoc } from "../../../shared/api/health/fragments.generated"
import * as Types from "../../../shared/types/__generated__/graphql"
import {
  ProductConfigurationModelsFragmentDoc,
  ProductConfigurationResponseFragmentDoc
} from "./product-configuration.fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ProductConfigurationQueryVariables = Exact<{
  productType: string
  variantKey: string
  configurationKey: string
  formData: string
  dimensioningKey: string
}>

export type ProductConfigurationQuery = {
  __typename: "Query"
  productConfiguration?: {
    __typename: "ProductConfigurationResponse"
    id: string
    configurationKey?: string | null
    dimensioningKey?: string | null
    variantKey?: string | null
    productType?: string | null
    accessories?: Array<string> | null
    schema?: any
    error?: string | null
    dimensioningOptions?: Array<{
      __typename: "DimensioningOption"
      dimensioningKey: string
      configurationKey?: string | null
      properties?: any
      variantKeyRelatedData?: Array<{
        __typename: "DimensioningParameter"
        default?: any
        readOnly?: boolean | null
        title?: string | null
        type?: string | null
        unit?: string | null
      }> | null
      physicalData?: Array<
        | {
            __typename: "DataTable"
            description?: string | null
            body?: Array<Array<{
              __typename: "DataTableCell"
              index?: number | null
              key?: string | null
              value?: any
            }> | null> | null
            header?: Array<{
              __typename: "DataTableCell"
              index?: number | null
              key?: string | null
              value?: any
            }> | null
          }
        | {
            __typename: "DimensioningParameter"
            default?: any
            readOnly?: boolean | null
            title?: string | null
            type?: string | null
            unit?: string | null
          }
      > | null
    }> | null
    originalConfiguration?: {
      __typename: "ProductConfigurationResponse"
      id: string
      configurationKey?: string | null
      dimensioningKey?: string | null
      variantKey?: string | null
      productType?: string | null
      accessories?: Array<string> | null
      schema?: any
      error?: string | null
      errors?: Array<{
        __typename: "APIError"
        code: string
        message?: string | null
        cause?: any
      }> | null
    } | null
    errors?: Array<{
      __typename: "APIError"
      code: string
      message?: string | null
      cause?: any
    }> | null
  } | null
}

export type ProductConfigurationModelsQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductConfigurationModelsQuery = {
  __typename: "Query"
  configurationModels?: {
    __typename: "ProductConfigurationModels"
    models?: Array<{
      __typename: "ProductConfigurationModel"
      id?: string | null
      dimUrl?: Array<{
        __typename: "ProductConfigurationModelDimInfo"
        label: string
        url: string
      }> | null
      followUps?: Array<{
        __typename: "ProductConfigurationModelFollowUp"
        id?: string | null
        dimUrl?: Array<{
          __typename: "ProductConfigurationModelDimInfo"
          label: string
          url: string
        }> | null
      }> | null
    }> | null
  } | null
}

export type ProductConfigurationHealthQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductConfigurationHealthQuery = {
  __typename: "Query"
  productConfigurationHealth?: {
    __typename: "Health"
    isAvailable: boolean
  } | null
}

export const ProductConfigurationDocument = gql`
  query ProductConfiguration(
    $productType: String!
    $variantKey: String!
    $configurationKey: String!
    $formData: String!
    $dimensioningKey: String!
  ) {
    productConfiguration(
      productType: $productType
      variantKey: $variantKey
      configurationKey: $configurationKey
      formData: $formData
      dimensioningKey: $dimensioningKey
    )
      @rest(
        type: "ProductConfigurationResponse"
        endpoint: "productConfiguration"
        path: "/{args.productType}?variantKey={args.variantKey}&configurationKey={args.configurationKey}&formData={args.formData}&dimensioningKey={args.dimensioningKey}"
      ) {
      ...ProductConfigurationResponse
    }
  }
  ${ProductConfigurationResponseFragmentDoc}
`

/**
 * __useProductConfigurationQuery__
 *
 * To run a query within a React component, call `useProductConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductConfigurationQuery({
 *   variables: {
 *      productType: // value for 'productType'
 *      variantKey: // value for 'variantKey'
 *      configurationKey: // value for 'configurationKey'
 *      formData: // value for 'formData'
 *      dimensioningKey: // value for 'dimensioningKey'
 *   },
 * });
 */
export function useProductConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductConfigurationQuery,
    ProductConfigurationQueryVariables
  > &
    (
      | { variables: ProductConfigurationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductConfigurationQuery,
    ProductConfigurationQueryVariables
  >(ProductConfigurationDocument, options)
}
export function useProductConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductConfigurationQuery,
    ProductConfigurationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductConfigurationQuery,
    ProductConfigurationQueryVariables
  >(ProductConfigurationDocument, options)
}
// @ts-ignore
export function useProductConfigurationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductConfigurationQuery,
    ProductConfigurationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProductConfigurationQuery,
  ProductConfigurationQueryVariables
>
export function useProductConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductConfigurationQuery,
        ProductConfigurationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductConfigurationQuery | undefined,
  ProductConfigurationQueryVariables
>
export function useProductConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductConfigurationQuery,
        ProductConfigurationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProductConfigurationQuery,
    ProductConfigurationQueryVariables
  >(ProductConfigurationDocument, options)
}
export type ProductConfigurationQueryHookResult = ReturnType<
  typeof useProductConfigurationQuery
>
export type ProductConfigurationLazyQueryHookResult = ReturnType<
  typeof useProductConfigurationLazyQuery
>
export type ProductConfigurationSuspenseQueryHookResult = ReturnType<
  typeof useProductConfigurationSuspenseQuery
>
export type ProductConfigurationQueryResult = Apollo.QueryResult<
  ProductConfigurationQuery,
  ProductConfigurationQueryVariables
>
export const ProductConfigurationModelsDocument = gql`
  query ProductConfigurationModels {
    configurationModels
      @rest(
        type: "ProductConfigurationModels"
        endpoint: "productConfigurationModels"
        path: ""
      ) {
      ...ProductConfigurationModels
    }
  }
  ${ProductConfigurationModelsFragmentDoc}
`

/**
 * __useProductConfigurationModelsQuery__
 *
 * To run a query within a React component, call `useProductConfigurationModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductConfigurationModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductConfigurationModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductConfigurationModelsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductConfigurationModelsQuery,
    ProductConfigurationModelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductConfigurationModelsQuery,
    ProductConfigurationModelsQueryVariables
  >(ProductConfigurationModelsDocument, options)
}
export function useProductConfigurationModelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductConfigurationModelsQuery,
    ProductConfigurationModelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductConfigurationModelsQuery,
    ProductConfigurationModelsQueryVariables
  >(ProductConfigurationModelsDocument, options)
}
// @ts-ignore
export function useProductConfigurationModelsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductConfigurationModelsQuery,
    ProductConfigurationModelsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProductConfigurationModelsQuery,
  ProductConfigurationModelsQueryVariables
>
export function useProductConfigurationModelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductConfigurationModelsQuery,
        ProductConfigurationModelsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductConfigurationModelsQuery | undefined,
  ProductConfigurationModelsQueryVariables
>
export function useProductConfigurationModelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductConfigurationModelsQuery,
        ProductConfigurationModelsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProductConfigurationModelsQuery,
    ProductConfigurationModelsQueryVariables
  >(ProductConfigurationModelsDocument, options)
}
export type ProductConfigurationModelsQueryHookResult = ReturnType<
  typeof useProductConfigurationModelsQuery
>
export type ProductConfigurationModelsLazyQueryHookResult = ReturnType<
  typeof useProductConfigurationModelsLazyQuery
>
export type ProductConfigurationModelsSuspenseQueryHookResult = ReturnType<
  typeof useProductConfigurationModelsSuspenseQuery
>
export type ProductConfigurationModelsQueryResult = Apollo.QueryResult<
  ProductConfigurationModelsQuery,
  ProductConfigurationModelsQueryVariables
>
export const ProductConfigurationHealthDocument = gql`
  query ProductConfigurationHealth {
    productConfigurationHealth
      @rest(
        type: "ProductConfigurationHealth"
        endpoint: "health"
        path: "/product-configuration/health"
      ) {
      ...Health
    }
  }
  ${HealthFragmentDoc}
`

/**
 * __useProductConfigurationHealthQuery__
 *
 * To run a query within a React component, call `useProductConfigurationHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductConfigurationHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductConfigurationHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductConfigurationHealthQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductConfigurationHealthQuery,
    ProductConfigurationHealthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductConfigurationHealthQuery,
    ProductConfigurationHealthQueryVariables
  >(ProductConfigurationHealthDocument, options)
}
export function useProductConfigurationHealthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductConfigurationHealthQuery,
    ProductConfigurationHealthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductConfigurationHealthQuery,
    ProductConfigurationHealthQueryVariables
  >(ProductConfigurationHealthDocument, options)
}
// @ts-ignore
export function useProductConfigurationHealthSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductConfigurationHealthQuery,
    ProductConfigurationHealthQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProductConfigurationHealthQuery,
  ProductConfigurationHealthQueryVariables
>
export function useProductConfigurationHealthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductConfigurationHealthQuery,
        ProductConfigurationHealthQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductConfigurationHealthQuery | undefined,
  ProductConfigurationHealthQueryVariables
>
export function useProductConfigurationHealthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductConfigurationHealthQuery,
        ProductConfigurationHealthQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProductConfigurationHealthQuery,
    ProductConfigurationHealthQueryVariables
  >(ProductConfigurationHealthDocument, options)
}
export type ProductConfigurationHealthQueryHookResult = ReturnType<
  typeof useProductConfigurationHealthQuery
>
export type ProductConfigurationHealthLazyQueryHookResult = ReturnType<
  typeof useProductConfigurationHealthLazyQuery
>
export type ProductConfigurationHealthSuspenseQueryHookResult = ReturnType<
  typeof useProductConfigurationHealthSuspenseQuery
>
export type ProductConfigurationHealthQueryResult = Apollo.QueryResult<
  ProductConfigurationHealthQuery,
  ProductConfigurationHealthQueryVariables
>
